import {GET_SALESMANS,GET_SALESMAN,ADD_SALESMAN,UPDATE_SALESMAN,DELETE_SALESMAN} from "../types";

const initialState = {list: [], single: null};

const reducer = (state = initialState, action) => {
    const {type, payload} = action;

    switch (type) {
        case GET_SALESMANS:
            return {...state, list: payload};

        case GET_SALESMAN:
            return {
                ...state,
                list: [payload, ...state.list],
            };
        case ADD_SALESMAN:
            return {
                ...state,
                list: [payload, ...state.list],
            };

        case UPDATE_SALESMAN:
            return {
                ...state,
                list: state.list.map((item) =>
                    item.id === payload.id ? payload : item
                ),
            };

            default:
            return state;
    }
};

export default reducer;
